import BaseLayer from "./BaseLayer";
import {drawRectangle, getCountyKey, mapMotorToCanvas} from "../utils/map_utils";

class RescannedTiles extends BaseLayer {
    id = "rescannedTiles";
    label = "Rescanned Tiles";
    defaultVisible = this.props.tileViewerState[this.id];

    draw = () => new Promise((resolve, reject) => {
        let {y_fields, tile_width, tile_height, uperpixel} = this.props.slide;
        let {streaks, deviceSettings, tileFlag} = this.props;
        if ("streaks" in streaks)
            streaks = streaks["streaks"];

        Object.values(streaks).forEach(streak => {
            let streakSecond = streak['second'];
            Object.values(streakSecond).forEach(value => {
                if (value['countyKey']['islandKey']['takeNumber'] === 1) {
                    Object.values(value['scanCells']).forEach((scanCell, index) => {
                        let motorX = scanCell['position']['xPosition'];
                        let motorY = scanCell['position']['yPosition'];
                        let {x, y} = mapMotorToCanvas(motorX, motorY, this.props.slide,
                            {device_settings: deviceSettings});
                        if (tileFlag['reverseYTileOrder']['flagY'])
                            y = y_fields * (tile_height * uperpixel) - y;
                        let xImageCoord = Math.floor(x / (tile_width * uperpixel));
                        let yImageCoord = Math.floor(y / (tile_height * uperpixel));


                        const islandKey = value['countyKey']['islandKey'];
                        const countyId = value['countyKey']['countyId'];
                        if (scanCell['info'][getCountyKey(islandKey, countyId)].takeImage) {
                            let bounds = [
                                [xImageCoord * (tile_width * uperpixel), yImageCoord * (tile_height * uperpixel)],
                                [(xImageCoord + 1) * (tile_width * uperpixel), yImageCoord * (tile_height * uperpixel)],
                                [(xImageCoord + 1) * (tile_width * uperpixel), (yImageCoord + 1) * (tile_height * uperpixel)],
                                [xImageCoord * (tile_width * uperpixel), (yImageCoord + 1) * (tile_height * uperpixel)],
                                [xImageCoord * (tile_width * uperpixel), yImageCoord * (tile_height * uperpixel)]
                            ];
                            drawRectangle(bounds, this.layer.getSource(), false, 1, "#eaff00");
                        }
                        if (scanCell.rescan) {
                            let bounds = [
                                [(xImageCoord + 0.25) * (tile_width * uperpixel), (yImageCoord + 0.25) * (tile_height * uperpixel)],
                                [(xImageCoord + 0.75) * (tile_width * uperpixel), (yImageCoord + 0.25) * (tile_height * uperpixel)],
                                [(xImageCoord + 0.75) * (tile_width * uperpixel), (yImageCoord + 0.75) * (tile_height * uperpixel)],
                                [(xImageCoord + 0.25) * (tile_width * uperpixel), (yImageCoord + 0.75) * (tile_height * uperpixel)],
                                [(xImageCoord + 0.5) * (tile_width * uperpixel), (yImageCoord + 0.5) * (tile_height * uperpixel)]
                            ];
                            if (value['islandId'] > 1000) {
                                drawRectangle(bounds, this.layer.getSource(), false, 1, "#00FF00");
                            } else {
                                drawRectangle(bounds, this.layer.getSource(), false, 3, "#F5F5F5");
                            }
                        }
                    });
                }
            });
        });
        resolve();
    })

}

export default RescannedTiles;